// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 16:15:05

export default {
  "id": "mahjong-slide-puzzle",
  "slug": "mahjong-slide-puzzle",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/10d9f5e5cec04793806e91e5d58db9da-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/10d9f5e5cec04793806e91e5d58db9da/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Mahjong Slide Puzzle",
      "description": "Experience the thrill of Mahjong puzzles! Strategically match tiles, clear the board, and conquer challenging levels to achieve high scores!",
      "instructions": "In the game, you need to move cards by tapping or sliding the screen, ensuring that cards with the same pattern are unobstructed horizontally or vertically.",
      "genres": [
        "Mahjong & Connect"
      ],
      "tags": [
        "2d",
        "logic",
        "logical",
        "matching",
        "sliding"
      ]
    },
    "zh-CN": {
      "title": "麻将滑动拼图",
      "description": "体验麻将拼图带来的激动！策略性地匹配牌面，清除桌面，征服挑战关卡，实现高分！",
      "instructions": "在游戏中，您需要通过点击或滑动屏幕来移动卡片，确保带有相同图案的卡片在水平或垂直方向上不受阻碍。",
      "genres": [
        "麻将 & 连接"
      ],
      "tags": [
        "二维",
        "逻辑",
        "逻辑性",
        "匹配",
        "滑动"
      ]
    },
    "zh-TW": {
      "title": "麻將滑動拼圖",
      "description": "體驗麻將拼圖的刺激！策略性地匹配Tile，清空棋盤，征服挑戰性等級，獲得高分！",
      "instructions": "在遊戲中，您需要透過點擊或滑動螢幕來移動卡片，確保具有相同圖案的卡片在水平或垂直方向上無阻礙。",
      "genres": [
        "麻将 & 連結"
      ],
      "tags": [
        "2D",
        "邏輯",
        "邏輯性",
        "匹配",
        "滑動"
      ]
    },
    "zh-HK": {
      "title": "麻將滑動拼圖",
      "description": "體驗麻將拼圖的刺激！策略性地匹配骨牌，清空棋盤，征服挑戰等級，達成高分！",
      "instructions": "在遊戲中，你需要透過觸控或滑動螢幕來移動卡片，確保同樣圖案卡片在水平或垂直方向上沒有阻礙。",
      "genres": [
        "麻將 & 連接"
      ],
      "tags": [
        "二維",
        "邏輯",
        "邏輯學",
        "配對",
        "滑動"
      ]
    },
    "ja": {
      "title": "麻雀スライドパズル",
      "description": "麻雀パズルの興奮を体験しよう！タイルを戦略的に一致させ、ボードをクリアし、挑戦的なレベルを征服して高スコアを達成しよう！",
      "instructions": "ゲームでは、タップやスクリーンをスライドしてカードを動かし、同じパターンのカードが水平または垂直に邪魔されないようにする必要があります。",
      "genres": [
        "麻雀 & 接続"
      ],
      "tags": [
        "2D",
        "ロジック",
        "論理的",
        "一致",
        "スライディング"
      ]
    },
    "ko": {
      "title": "마작 슬라이드 패uzzle",
      "description": "마작 퍼즐의 즐거움을 경험해보세요! 타일을 전략적으로 매칭하고 보드를 cleared하며 도전적인 레벨을克服하여 높은 점수를 달성하세요!",
      "instructions": "게임에서는 터치나 스크린을 드래그하여 카드를 이동시켜 같은 패턴의 카드가 수직이나 수평으로 방해없이 이동하도록 해야 합니다.",
      "genres": [
        "마작 & 커넥트"
      ],
      "tags": [
        "2D",
        "논리적",
        "논리",
        "매칭",
        "슬라이딩"
      ]
    },
    "fr": {
      "title": "Puzzle de glisse de Mahjong",
      "description": "Profitez de l'adrénaline des puzzles de Mahjong ! Associatez stratégiquement les tuiles, nettoyez le plateau et conquérez des niveaux défiants pour réaliser de hautes notes !",
      "instructions": "Dans le jeu, vous devez déplacer les cartes en tapant ou glissant sur l'écran, en vous assurant que les cartes avec le même motif soient débloquées horizontalement ou verticalement.",
      "genres": [
        "Mahjong et Connect"
      ],
      "tags": [
        "2D",
        "logique",
        "logique",
        "correspondance",
        "glissant"
      ]
    }
  }
};
